import { cn } from "@faire/prototype-playground/lib/utils";
import React from "react";

export interface IconButtonProps {
  icon: React.ReactNode;
  onClick?: () => void;
  ariaLabel: string;
  className?: string;
  type?: "button" | "submit" | "reset";
}

/**
 * IconButton - A circular icon button component
 * Based on Faire design system icon button pattern
 */
export default function IconButton({
  icon,
  onClick,
  ariaLabel,
  className = "",
  type = "button",
}: IconButtonProps) {
  return (
    <button
      type={type}
      onClick={onClick}
      aria-label={ariaLabel}
      className={cn(
        "bg-fs-surface-primary flex w-12 items-center justify-center rounded-full border border-[#dfe0e1] transition-colors duration-200 ease-in-out hover:bg-(--slate-color-action-surface-inverse-hover) focus:ring-2 focus:ring-[#333333] focus:ring-offset-2 focus:outline-hidden",
        className
      )}
      style={{ height: "48px", width: "48px" }}
    >
      {icon}
    </button>
  );
}
